const state = {
    errors: [],
    show: false
}

// getters
const getters = {
    errors: state => state.errors,
    error: state => state.errors.length ? state.errors[state.errors.length - 1] : null,
    show: state => state.show && state.errors.length
}

// actions
const actions = {
    show ({ commit }) {
        commit('setShow', true)
    },
    hide ({ commit }) {
        commit('setShow', false)
    },
    add ({ commit }, error) {
        commit('addError', error)
    }
}

// mutations
const mutations = {
    setShow (state, show) {
        state.show = show
    },
    addError (state, error) {
        state.errors.push(error)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
